import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IState {
  currentScreen: string;
  currentCreateMemberSection: string;
  isHamburgerToolBarOpen: boolean;
  currentConfigurationMenu: string;
  currentMenu: string;
  adminUserScreen: string;
  isNavigationfromEventToMember: boolean;
}

const initialState: IState = {
  currentScreen: "DashBoard",
  currentCreateMemberSection: "Personal",
  isHamburgerToolBarOpen: false,
  currentConfigurationMenu: "AdminUserConfiguration",
  currentMenu: "MemberList",
  adminUserScreen: "AdminUserListScreen",
  isNavigationfromEventToMember: false,
};

export const counterSlice = createSlice({
  name: "screen",
  initialState,
  reducers: {
    // screenChange: (state: any, action: PayloadAction<string>) => {
    //   console.log(action.payload);
    //   state.currentScreen = action.payload;
    // },
    hamburgermenu(state: any, action: PayloadAction<boolean>) {
      state.isHamburgerToolBarOpen = action.payload;
    },
    changeCreateMemberSection(state: any, action: PayloadAction<string>) {
      state.currentCreateMemberSection = action.payload;
    },

    changeCurrentConfigurationMenu(state: any, action: PayloadAction<string>) {
      state.currentConfigurationMenu = action.payload;
    },
    changeCurrentMemberMenu(state: any, action: PayloadAction<string>) {
      state.currentMenu = action.payload;
    },
    changeAdminUserScreen(state: any, action: PayloadAction<string>) {
      state.adminUserScreen = action.payload;
    },
    changeisNavigationFromEventToMember(
      state: any,
      action: PayloadAction<boolean>
    ) {
      state.isNavigationfromEventToMember = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  // screenChange,
  hamburgermenu,
  changeCreateMemberSection,
  changeCurrentConfigurationMenu,
  changeAdminUserScreen,
  changeCurrentMemberMenu,
  changeisNavigationFromEventToMember,
} = counterSlice.actions;

export default counterSlice.reducer;
